import { useState } from 'react'

import axios from '../services/axios'
import useCsrf from './useCsrf'

const useUpdateReviewRequestFeedback = (requestSlug, feedbackSlug) => {
  const csrf = useCsrf()

  const [error, setError] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [latestSlug, setLatestSlug] = useState()

  const reset = () => {
    setError()
    setLatestSlug()

    setIsError(false)
    setIsLoading(false)
    setIsSuccess(false)
  }

  const submitData = async (data) => {
    if (feedbackSlug) {
      return await axios.put(
        `/public/review-request/${requestSlug}/review-request-feedback/${feedbackSlug}`,
        data
      )
    }

    return await axios.post(
      `/public/review-request/${requestSlug}/review-request-feedback`,
      data
    )
  }

  const updateReviewRequestFeedback = async (data) => {
    reset()

    setIsLoading(true)

    try {
      await csrf()
    } catch {
      setIsError(true)
      setIsLoading(false)

      return
    }

    try {
      const result = await submitData(data)

      setLatestSlug(result?.data?.data?.slug)
      setIsSuccess(true)
    } catch (axiosError) {
      setError(
        axiosError?.response?.data?.errors ||
          axiosError?.response?.data?.message ||
          'An unknown error occurred. Please try again'
      )
      setIsError(true)
    }

    setIsLoading(false)
  }

  return [
    updateReviewRequestFeedback,
    { error, isError, isLoading, isSuccess, latestSlug },
  ]
}

export default useUpdateReviewRequestFeedback
